var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<a\n  class=\"p-article-feature__list__item__link\"\n  href=\"https://mamari.jp/feature/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  <div class=\"p-article-feature__list__item__link__left-content\">\n    <div class=\"p-article-feature__list__item__link__left-content__thumb\">\n      <img class=\"p-article-feature__list__item__link__left-content__thumb__image\" src=\"";
  if (helper = helpers.cover_image_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.cover_image_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    </div>\n  </div>\n  <div class=\"p-article-feature__list__item__link__right-content\">\n    <p class=\"p-article-feature__list__item__link__right-content__headline\">\n      ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n    </p>\n  </div>\n</a>\n";
  return buffer;
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/feature_list_item.hbs
// module id = 225
// module chunks = 0